import { useMemo, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useSamplePacks } from '../../../../queries/samplePacks'
import CenteredLoadingAnimation from '../../../core/CenteredLoadingAnimation'
import { Box } from '../../../core/Components'
import { SamplePackDropdown } from './SamplePackDropdown'

export const SamplePacks = () => {
  const perPage = 20
  const samplePacksQuery = useSamplePacks({ params: { perPage, order: 'desc' } })
  const [activeSamplePackId, setActiveSamplePackId] = useState(0)

  const samplePacks = useMemo(
    () =>
      samplePacksQuery.data?.pages.flatMap((page) => page.data.map((samplePack) => samplePack)) ||
      [],
    [samplePacksQuery.data]
  )

  const handleSelectSamplePack = (samplePackId: number) => {
    if (samplePackId === activeSamplePackId) {
      return setActiveSamplePackId(0)
    }

    setActiveSamplePackId(samplePackId)
  }

  return (
    <>
      {samplePacksQuery.isLoading && <CenteredLoadingAnimation />}
      {!samplePacksQuery.isLoading && (
        <InfiniteScroll
          loader={<CenteredLoadingAnimation />}
          dataLength={samplePacksQuery.data?.pages.length * perPage}
          next={samplePacksQuery.fetchNextPage}
          hasMore={samplePacksQuery.hasNextPage}
          style={{ overflow: 'visible' }}
        >
          {samplePacks.map((samplePack, index) => {
            if (samplePack.edition) return null
            return (
              <Box key={samplePack.id}>
                <SamplePackDropdown
                  samplePack={samplePack}
                  isActive={activeSamplePackId === samplePack.id}
                  handleSelect={() => handleSelectSamplePack(samplePack.id)}
                />
              </Box>
            )
          })}
        </InfiniteScroll>
      )}
    </>
  )
}
